var map = {
	"./NotificatonOnButton.svg": "MRP4",
	"./add.svg": "58n+",
	"./anq.svg": "m/1o",
	"./codeConsole.svg": "zHkQ",
	"./collection.svg": "a4vn",
	"./date.svg": "Ve8B",
	"./dp.svg": "+BKk",
	"./dp2.svg": "BRHg",
	"./email.svg": "+4G4",
	"./hobby.svg": "AzDy",
	"./home.svg": "U9Ws",
	"./icon.svg": "vUvT",
	"./index.svg": "YYNh",
	"./ipvisits.svg": "UHzf",
	"./lock.svg": "FnAU",
	"./log.svg": "8uFK",
	"./logo.svg": "ZY77",
	"./logoEn.svg": "L8Yr",
	"./mail.svg": "CFfD",
	"./mailT.svg": "RvZf",
	"./menu.svg": "dH9r",
	"./monitor.svg": "Lu+8",
	"./myex.svg": "KOod",
	"./notification.svg": "2V/f",
	"./notificationT.svg": "h/hv",
	"./pasT.svg": "iIck",
	"./password.svg": "QjmH",
	"./peoples.svg": "TgHK",
	"./permission.svg": "j4kZ",
	"./redis.svg": "riER",
	"./role.svg": "cqqK",
	"./sqlMonitor.svg": "EjRr",
	"./system.svg": "Jax1",
	"./timeout.svg": "+EHs",
	"./unlock.svg": "JNNJ",
	"./user.svg": "VdD3",
	"./user1.svg": "Ebwp",
	"./userT.svg": "NcoZ",
	"./version.svg": "uVf0",
	"./vip.svg": "WRQj",
	"./visits.svg": "Dmhz",
	"./zujian.svg": "ILQa"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 32